'use strict';
const qs = require('querystring');
const url = require('url');
const client = {
  https: require('https'),
  http: require('http'),
};

const REDIRECT_CODES = [301, 302, 303, 307];
class SimpleError extends Error {
  constructor() {
    super('Error happened due to simple constraint not being 2xx status code.');
    this.name = 'FR_Simple';
  }
}
class RequestError extends Error {
  constructor(e) {
    super('Error happened reguarding a request: ' + e.message);
    this.name = 'FR_Request_' + e.name;
  }
}

class RequestTimeoutError extends Error {
  constructor(e) {
    super('Error happened reguarding a request: ' + e.message);
    this.name = 'FR_Request_Timeout';
  }
}

class Fasquest {
  constructor() {
    this.agent = {
      http: new client.http.Agent({
        keepAlive: true,
      }),
      https: new client.https.Agent({
        keepAlive: true,
      }),
    };
  }
  request(options, cb = null) {
    if (!cb) {
      return this.requestPromise(options);
    } else {
      this._request(options, (req, res, err) => {
        cb({
          req,
          res,
          err,
        });
      });
    }
  }
  requestPromise(options) {
    return new Promise((resolve, reject) => {
      this._request(options, (req, res, err) => {
        if (err) {
          reject({
            req,
            res,
            err,
          });
        } else {
          resolve(options.resolveWithFullResponse ? res : res.body);
        }
      });
    });
  }
  _request(ops, cb, count = 0) {
    var options = this._setOptions(ops);

    var req = client[options.proto].request(options, (res) => {
      res.body = '';

      res.on('data', (chunk) => {
        res.body += chunk;
      });

      res.on('end', () => {
        if (options.timeout) {
          clearTimeout(t);
        }
        // remove as causes circular references

        if (
          REDIRECT_CODES.indexOf(res.statusCode) !== -1 &&
          count < options.redirect_max
        ) {
          options.uri = url.resolve(options.uri, res.headers.location);
          return this._request(this._setOptions(options), cb, ++count);
        } else {
          if (
            res.headers['content-type'] &&
            res.headers['content-type'].indexOf('json') > -1
          ) {
            try {
              res.body = JSON.parse(res.body);
            } catch (e) {
              // do nothing
            }
          }
          if (options.simple) {
            if (res.statusCode > 299 || res.statusCode < 200) {
              return cb(req, res, new SimpleError());
            }
          }
          return cb(req, res, null);
        }
      });
    });

    if (options.timeout) {
      var t = setTimeout(() => {
        req.destroy();
      }, options.timeout || 60000);
    }

    req.on('error', (e) => {
      var err =
        e.message.indexOf('socket hang up') > -1
          ? new RequestTimeoutError(e)
          : new RequestError(e);

      return cb(req, null, err);
    });

    if (options.body) {
      req.write(options.body);
    }
    req.end();
  }
  _setOptions(opts) {
    var options = {};

    options.simple = opts.simple !== false;
    options.method = opts.method || 'GET';
    options.uri = opts.uri;
    options.timeout = opts.timeout;

    if (opts.qs) {
      var escQS = qs.stringify(opts.qs);

      if (escQS.length > 0) {
        options.uri += (options.uri.indexOf('?') > -1 ? '&' : '?') + escQS;
      }
    }
    options = this._uri_to_options(options.uri, options);
    options.agent = opts.agent || this.agent[opts.proto];
    options.headers = {};
    if (opts.headers) {
      var h = Object.keys(opts.headers);

      for (var i = 0; i < h.length; i++) {
        options.headers[h[i]] = opts.headers[h[i]];
      }
    }
    if (opts.json) {
      options.headers['Content-Type'] = 'application/json';
      if (opts.body) {
        options.body = JSON.stringify(opts.body);
      }
    } else if (opts.form) {
      options.body = qs.stringify(opts.form);

      options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
      options.headers['Content-Length'] = Buffer.byteLength(options.body);
    } else if (opts.body) {
      options.headers['Content-Length'] = Buffer.byteLength(opts.body);
      if (!options.headers['Content-Type']) {
        options.headers['Content-Type'] = 'text/plain';
      }
      options.body = opts.body;
    }
    if (opts.authorization) {
      if (opts.authorization.basic) {
        options.headers['Authorization'] =
          'Basic ' +
          Buffer.from(
            opts.authorization.basic.client +
              ':' +
              opts.authorization.basic.secret,
            'ascii'
          ).toString('base64');
      } else if (opts.authorization.bearer) {
        options.headers['Authorization'] =
          'Bearer ' + opts.authorization.bearer;
      }
    }
    if (!opts.redirect_max && opts.redirect_max !== 0) {
      options.redirect_max = 5;
    }

    return options;
  }
  _uri_to_options(uri, options) {
    var convertedUri = {
      proto: '',
      path: '',
      port: 80,
      host: '',
    };
    var splitURI = uri.split('://');

    convertedUri.proto = splitURI[0];
    var possiblePort = splitURI[1].indexOf(':');

    if (possiblePort > -1 && !isNaN(splitURI[1][possiblePort + 1])) {
      const pindex = splitURI[1].indexOf('/');

      if (pindex > -1) {
        convertedUri.path = splitURI[1].slice(pindex);
        convertedUri.port = splitURI[1].slice(possiblePort + 1, pindex);
      } else {
        convertedUri.port = splitURI[1].slice(possiblePort + 1);
      }
      convertedUri.host = splitURI[1].slice(0, possiblePort);
    } else {
      convertedUri.port = convertedUri.proto == 'https' ? 443 : 80;
    }
    const hostIndex = splitURI[1].indexOf('/');

    if (hostIndex > -1) {
      convertedUri.path = convertedUri.path || splitURI[1].slice(hostIndex);
      convertedUri.host = convertedUri.host || splitURI[1].slice(0, hostIndex);
    } else {
      convertedUri.path = convertedUri.path || '/';
      convertedUri.host = convertedUri.host || splitURI[1];
    }
    options.proto = convertedUri.proto;
    options.path = convertedUri.path;
    options.port = convertedUri.port;
    options.host = convertedUri.host;
    return options;
  }
}
module.exports = new Fasquest();

/**
 * SDK - importing the SDK for use
 * @param {string} host the hostname to the service (example: http://127.0.0.1)
 * @param {object} opts options that will be appened to every request. [Fasquest Lib Options](https://github.com/Phara0h/Fasquest) (example: {headers: {'API-KEY':'34098hodf'}})
 * @example
 * init
 * ```js
 * const { Seo } = require('./sdk.js')('http://127.0.0.1');
 * ```
 */
function SDK(host, opts) {
  var hostUrl = '';
  var defaultOpts = null;

  if (host) {
    hostUrl = host;
  }
  if (opts) {
    defaultOpts = opts;
  }
  const fasq = new Fasquest();

  /**
   *
   */
  class Seo {
    constructor() {}
    static get _postgenClassUrls() {
      return {
        reload: 'seo/v1/reload/:key',
        healthcheck: 'seo/health',
        metrics: 'seo/metrics',
      };
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    /**
     * reload -
     *
     * Path: seo/v1/reload/:key
     * @param {any} key  (example: cniudkzjhIYUHSiejiSiOSKeijdfslw237398217ids98wej)
     */
    static async reload(key, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `seo/v1/reload/${key}`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * healthCheck - server's health check
     *
     * Path: seo/health
     */
    static async healthCheck(opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `seo/health`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * metrics - servers metrics
     *
     * Path: seo/metrics
     */
    static async metrics(opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `seo/metrics`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    static get NameRanges() {
      return NameRanges;
    }

    static get Fullnames() {
      return Fullnames;
    }

    static get Top2000() {
      return Top2000;
    }

    static get Top10000() {
      return Top10000;
    }

    static get Top1000() {
      return Top1000;
    }
  }
  /**
   *
   */
  class NameRanges {
    constructor() {}
    static get _postgenClassUrls() {
      return {
        bypeople: 'seo/v1/name-ranges/people',
        byletter: 'seo/v1/name-ranges/letter/:letter',
      };
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    /**
     * byPeople -
     *
     * Path: seo/v1/name-ranges/people
     */
    static async byPeople(opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `seo/v1/name-ranges/people`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * byLetter -
     *
     * Path: seo/v1/name-ranges/letter/:letter
     * @param {any} letter  (example: Q)
     * @param {any} primary  (example: 001)
     * @param {any} secondary  (example: 001)
     */
    static async byLetter(letter, primary, secondary, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `seo/v1/name-ranges/letter/${letter}`,
        qs: { primary, secondary },
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }
  }
  /**
   *
   */
  class Fullnames {
    constructor() {}
    static get _postgenClassUrls() {
      return { byletterpage: 'seo/v1/fullnames/letter/:letter/:page' };
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    /**
     * byLetterPage -
     *
     * Path: seo/v1/fullnames/letter/:letter/:page
     * @param {any} letter letter to get top names list for (example: H)
     * @param {any} page
     */
    static async byLetterPage(letter, page, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `seo/v1/fullnames/letter/${letter}/${page}`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }
  }
  /**
   *
   */
  class Top2000 {
    constructor() {}
    static get _postgenClassUrls() {
      return { bydecade: 'seo/v1/top2000/firstnames/decade/:decade' };
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    /**
     * byDecade -
     *
     * Path: seo/v1/top2000/firstnames/decade/:decade
     * @param {any} decade
     */
    static async byDecade(decade, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `seo/v1/top2000/firstnames/decade/${decade}`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }
  }
  /**
   *
   */
  class Top10000 {
    constructor() {}
    static get _postgenClassUrls() {
      return {};
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    static get Firstnames() {
      return Top10000Firstnames;
    }
  }
  /**
   *
   */
  class Top10000Firstnames {
    constructor() {}
    static get _postgenClassUrls() {
      return { bygender: 'seo/v1/top10000/firstnames/gender/:gender' };
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    /**
     * byGender -
     *
     * Path: seo/v1/top10000/firstnames/gender/:gender
     * @param {any} gender  (example: M)
     */
    static async byGender(gender, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `seo/v1/top10000/firstnames/gender/${gender}`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }
  }
  /**
   *
   */
  class Top1000 {
    constructor() {}
    static get _postgenClassUrls() {
      return {};
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    static get Lastnames() {
      return Top1000Lastnames;
    }

    static get Fullnames() {
      return Top1000Fullnames;
    }
  }
  /**
   *
   */
  class Top1000Lastnames {
    constructor() {}
    static get _postgenClassUrls() {
      return {
        allletters: 'seo/v1/top1000/lastnames/letter',
        byletter: 'seo/v1/top1000/lastnames/letter/:letter',
        bystate: 'seo/v1/top1000/lastnames/state/:state',
        all: 'seo/v1/top1000/lastnames/all',
      };
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    /**
     * allLetters -
     *
     * Path: seo/v1/top1000/lastnames/letter
     */
    static async allLetters(opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `seo/v1/top1000/lastnames/letter`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * byLetter -
     *
     * Path: seo/v1/top1000/lastnames/letter/:letter
     * @param {any} letter letter to get top names list for (example: H)
     */
    static async byLetter(letter, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `seo/v1/top1000/lastnames/letter/${letter}`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * byState -
     *
     * Path: seo/v1/top1000/lastnames/state/:state
     * @param {any} state state to get list of names for (example: FL)
     */
    static async byState(state, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `seo/v1/top1000/lastnames/state/${state}`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * all -
     *
     * Path: seo/v1/top1000/lastnames/all
     */
    static async all(opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `seo/v1/top1000/lastnames/all`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }
  }
  /**
   *
   */
  class Top1000Fullnames {
    constructor() {}
    static get _postgenClassUrls() {
      return {
        bydate: 'seo/v1/top1000/fullnames/year/:year/month/:month/day/:day',
        bystate: 'seo/v1/top1000/fullnames/state/:state',
      };
    }
    static getFunctionsPath(name) {
      return this._postgenClassUrls[name.toLowerCase()];
    }

    /**
     * byDate -
     *
     * Path: seo/v1/top1000/fullnames/year/:year/month/:month/day/:day
     * @param {any} year  (example: 2021)
     * @param {any} month  (example: 1)
     * @param {any} day  (example: 1)
     */
    static async byDate(year, month, day, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri:
          hostUrl +
          '/' +
          `seo/v1/top1000/fullnames/year/${year}/month/${month}/day/${day}`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }

    /**
     * byState -
     *
     * Path: seo/v1/top1000/fullnames/state/:state
     * @param {any} state state to get list of names for (example: FL)
     */
    static async byState(state, opts) {
      var options = {
        method: 'GET',
        simple: false,
        uri: hostUrl + '/' + `seo/v1/top1000/fullnames/state/${state}`,
      };
      if (defaultOpts) {
        options = Object.assign(options, defaultOpts);
      }
      if (opts) {
        options = Object.assign(options, opts);
      }
      return await fasq.request(options);
    }
  }

  return {
    Seo,
    NameRanges,
    Fullnames,
    Top2000,
    Top10000,
    Top10000Firstnames,
    Top1000,
    Top1000Lastnames,
    Top1000Fullnames,
  };
}
module.exports = SDK;

